{
  "about.blocks": "Servitores moderate",
  "about.contact": "Contacto:",
  "about.default_locale": "Default",
  "about.disclaimer": "Mastodon es software libere, de codice aperte, e un marca de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Ration non disponibile",
  "about.domain_blocks.preamble": "Mastodon generalmente permitte vider le contento de, e interager con, usatores de qualcunque altere servitor in le fediverso. Istes es le exceptiones que ha essite facite sur iste servitor particular.",
  "about.domain_blocks.silenced.explanation": "Generalmente, tu non videra le profilos e le contento de iste servitor, excepte si tu expressemente cerca le contento o seque le profilos.",
  "about.domain_blocks.silenced.title": "Limitate",
  "about.domain_blocks.suspended.explanation": "Nulle datos de iste servitor essera processate, immagazinate o excambiate, rendente omne interaction o communication con usatores de iste servitor impossibile.",
  "about.domain_blocks.suspended.title": "Suspendite",
  "about.language_label": "Lingua",
  "about.not_available": "Iste information non ha essite rendite disponibile sur iste servitor.",
  "about.powered_by": "Rete social decentralisate, actionate per {mastodon}",
  "about.rules": "Regulas del servitor",
  "account.account_note_header": "Nota personal",
  "account.add_or_remove_from_list": "Adder a, o remover de listas",
  "account.badges.bot": "Automatisate",
  "account.badges.group": "Gruppo",
  "account.block": "Blocar @{name}",
  "account.block_domain": "Blocar dominio {domain}",
  "account.block_short": "Blocar",
  "account.blocked": "Blocate",
  "account.cancel_follow_request": "Cancellar sequimento",
  "account.copy": "Copiar ligamine a profilo",
  "account.direct": "Mentionar privatemente @{name}",
  "account.disable_notifications": "Non plus notificar me quando @{name} publica",
  "account.edit_profile": "Modificar profilo",
  "account.edit_profile_short": "Modificar",
  "account.enable_notifications": "Notificar me quando @{name} publica",
  "account.endorse": "Evidentiar sur le profilo",
  "account.familiar_followers_many": "Sequite per {name1}, {name2}, e {othersCount, plural, one {un altere que tu cognosce} other {# alteres que tu cognosce}}",
  "account.familiar_followers_one": "Sequite per {name1}",
  "account.familiar_followers_two": "Sequite per {name1} e {name2}",
  "account.featured": "In evidentia",
  "account.featured.accounts": "Profilos",
  "account.follow": "Sequer",
  "account.follow_back": "Sequer in retorno",
  "account.follow_back_short": "Sequer in retorno",
  "account.follow_request": "Requestar de sequer",
  "account.follow_request_cancel": "Cancellar requesta",
  "account.follow_request_cancel_short": "Cancellar",
  "account.follow_request_short": "Requesta",
  "account.followers": "Sequitores",
  "account.followers.empty": "Necuno seque ancora iste usator.",
  "account.followers_counter": "{count, plural, one {{counter} sequitor} other {{counter} sequitores}}",
  "account.followers_you_know_counter": "{counter} que tu cognosce",
  "account.following": "Sequente",
  "account.following_counter": "{count, plural, one {{counter} sequite} other {{counter} sequites}}",
  "account.follows.empty": "Iste usator non seque ancora alcuno.",
  "account.follows_you": "Te seque",
  "account.go_to_profile": "Vader al profilo",
  "account.hide_reblogs": "Celar impulsos de @{name}",
  "account.in_memoriam": "In memoriam.",
  "account.joined_short": "Inscribite",
  "account.languages": "Cambiar le linguas subscribite",
  "account.link_verified_on": "Le proprietate de iste ligamine ha essite verificate le {date}",
  "account.locked_info": "Le stato de confidentialitate de iste conto es definite como serrate. Le proprietario determina manualmente qui pote sequer le.",
  "account.media": "Multimedia",
  "account.mention": "Mentionar @{name}",
  "account.moved_to": "{name} ha indicate que su nove conto ora es:",
  "account.mute": "Silentiar @{name}",
  "account.mute_notifications_short": "Silentiar le notificationes",
  "account.mute_short": "Silentiar",
  "account.muted": "Silentiate",
  "account.mutual": "Sequimento mutue",
  "account.no_bio": "Nulle description fornite.",
  "account.open_original_page": "Aperir le pagina original",
  "account.posts": "Messages",
  "account.remove_from_followers": "Remover {name} del sequitores",
  "account.report": "Reportar @{name}",
  "account.requested_follow": "{name} ha requestate de sequer te",
  "account.share": "Compartir profilo de @{name}",
  "account.show_reblogs": "Monstrar impulsos de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "account.unblock": "Disblocar @{name}",
  "account.unblock_domain": "Disblocar dominio {domain}",
  "account.unblock_domain_short": "Disblocar",
  "account.unblock_short": "Disblocar",
  "account.unendorse": "Non evidentiar sur le profilo",
  "account.unfollow": "Non plus sequer",
  "account.unmute": "Non plus silentiar @{name}",
  "account.unmute_notifications_short": "Non plus silentiar le notificationes",
  "account.unmute_short": "Non plus silentiar",
  "account_note.placeholder": "Clicca pro adder un nota",
  "admin.dashboard.daily_retention": "Retention de usatores per die post inscription",
  "admin.dashboard.monthly_retention": "Retention de usatores per mense post inscription",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mense de inscription",
  "admin.dashboard.retention.cohort_size": "Nove usatores",
  "admin.impact_report.instance_accounts": "Numero de contos que isto delerea",
  "admin.impact_report.instance_followers": "Sequitores que nostre usatores perderea",
  "admin.impact_report.instance_follows": "Sequitores que lor usatores perderea",
  "admin.impact_report.title": "Summario de impacto",
  "alert.rate_limited.message": "Per favor retenta post {retry_time, time, medium}.",
  "alert.rate_limited.title": "Excesso de requestas",
  "alert.unexpected.message": "Un error inexpectate ha occurrite.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Texto alternative",
  "alt_text_modal.add_alt_text": "Adder texto alternative",
  "alt_text_modal.add_text_from_image": "Adder texto ab imagine",
  "alt_text_modal.cancel": "Cancellar",
  "alt_text_modal.change_thumbnail": "Cambiar le miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describe isto pro personas con impedimentos auditive…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describe isto pro personas con impedimentos visual…",
  "alt_text_modal.done": "Preste",
  "announcement.announcement": "Annuncio",
  "annual_report.summary.most_used_app.most_used_app": "application le plus usate",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashtag le plus usate",
  "annual_report.summary.new_posts.new_posts": "nove messages",
  "annual_report.summary.percentile.text": "<topLabel>Isto te pone in le prime</topLabel><percentage></percentage><bottomLabel>usatores de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Tu es un primo inter pares.",
  "attachments_list.unprocessed": "(non processate)",
  "audio.hide": "Celar audio",
  "block_modal.remote_users_caveat": "Nos demandera al servitor {domain} de respectar tu decision. Nonobstante, le conformitate non es garantite perque alcun servitores pote tractar le blocadas de maniera differente. Le messages public pote esser totevia visibile pro le usatores non authenticate.",
  "block_modal.show_less": "Monstrar minus",
  "block_modal.show_more": "Monstrar plus",
  "block_modal.they_will_know": "Le persona pote saper de esser blocate.",
  "block_modal.title": "Blocar usator?",
  "boost_modal.combo": "Tu pote premer {combo} pro saltar isto le proxime vice",
  "boost_modal.reblog": "Impulsar le message?",
  "boost_modal.undo_reblog": "Cessar de impulsar le message?",
  "bundle_column_error.copy_stacktrace": "Copiar reporto de error",
  "bundle_column_error.error.body": "Le pagina requestate non pote esser visualisate. Pote esser a causa de un defecto in nostre codice o de un problema de compatibilitate del navigator.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "Un error ha occurrite durante le cargamento de iste pagina. Isto pote esser a causa de un problema temporari con tu connexion a internet o con iste servitor.",
  "bundle_column_error.network.title": "Error de rete",
  "bundle_column_error.retry": "Tentar novemente",
  "bundle_column_error.return": "Retornar al initio",
  "bundle_column_error.routing.body": "Le pagina requestate non pote esser trovate. Es tu secur que le URL in le barra de adresse es correcte?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Clauder",
  "bundle_modal_error.message": "Un error ha occurrite durante le cargamento de iste schermo.",
  "bundle_modal_error.retry": "Tentar novemente",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} de {max, number}",
  "closed_registrations.other_server_instructions": "Perque Mastodon es decentralisate, tu pote crear un conto sur un altere servitor e totevia interager con iste servitor.",
  "closed_registrations_modal.description": "Crear un conto sur {domain} non es actualmente possibile, ma considera que non es necessari haber un conto specificamente sur {domain} pro usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Cercar un altere servitor",
  "closed_registrations_modal.preamble": "Mastodon es decentralisate, dunque, non importa ubi tu crea tu conto, tu pote sequer e communicar con omne persona sur iste servitor. Tu pote mesmo hospitar tu proprie servitor!",
  "closed_registrations_modal.title": "Crear un conto sur Mastodon",
  "column.about": "A proposito",
  "column.blocks": "Usatores blocate",
  "column.bookmarks": "Marcapaginas",
  "column.community": "Chronologia local",
  "column.create_list": "Crear lista",
  "column.direct": "Mentiones private",
  "column.directory": "Navigar profilos",
  "column.domain_blocks": "Dominios blocate",
  "column.edit_list": "Modificar lista",
  "column.favourites": "Favorites",
  "column.firehose": "Fluxos in vivo",
  "column.firehose_local": "Fluxo in vivo de iste servitor",
  "column.firehose_singular": "Fluxo in vivo",
  "column.follow_requests": "Requestas de sequimento",
  "column.home": "Initio",
  "column.list_members": "Gerer le membros del lista",
  "column.lists": "Listas",
  "column.mutes": "Usatores silentiate",
  "column.notifications": "Notificationes",
  "column.pins": "Messages fixate",
  "column.public": "Chronologia federate",
  "column_back_button.label": "Retro",
  "column_header.hide_settings": "Celar le parametros",
  "column_header.moveLeft_settings": "Mover columna al sinistra",
  "column_header.moveRight_settings": "Mover columna al dextra",
  "column_header.pin": "Fixar",
  "column_header.show_settings": "Monstrar le parametros",
  "column_header.unpin": "Disfixar",
  "column_search.cancel": "Cancellar",
  "community.column_settings.local_only": "Solmente local",
  "community.column_settings.media_only": "Solmente multimedia",
  "community.column_settings.remote_only": "A distantia solmente",
  "compose.error.blank_post": "Le message non pote esser vacue.",
  "compose.language.change": "Cambiar le lingua",
  "compose.language.search": "Cercar linguas...",
  "compose.published.body": "Message publicate.",
  "compose.published.open": "Aperir",
  "compose.saved.body": "Message salvate.",
  "compose_form.direct_message_warning_learn_more": "Apprender plus",
  "compose_form.encryption_warning": "Le messages sur Mastodon non es cryptate de puncta a puncta. Non condivide alcun information sensibile usante Mastodon.",
  "compose_form.hashtag_warning": "Iste message non essera listate sub alcun hashtag perque illo non es public. Solmente le messages public pote esser cercate per hashtag.",
  "compose_form.lock_disclaimer": "Tu conto non es {locked}. Quicunque pote sequer te pro vider tu messages solo pro sequitores.",
  "compose_form.lock_disclaimer.lock": "serrate",
  "compose_form.placeholder": "Que ha tu in mente?",
  "compose_form.poll.duration": "Durata del sondage",
  "compose_form.poll.multiple": "Selection multiple",
  "compose_form.poll.option_placeholder": "Option {number}",
  "compose_form.poll.single": "Option singule",
  "compose_form.poll.switch_to_multiple": "Cambiar le sondage pro permitter selectiones multiple",
  "compose_form.poll.switch_to_single": "Cambiar le sondage pro permitter selection singule",
  "compose_form.poll.type": "Stilo",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Actualisar",
  "compose_form.spoiler.marked": "Remover advertimento de contento",
  "compose_form.spoiler.unmarked": "Adder advertimento de contento",
  "compose_form.spoiler_placeholder": "Advertimento de contento (optional)",
  "confirmation_modal.cancel": "Cancellar",
  "confirmations.block.confirm": "Blocar",
  "confirmations.delete.confirm": "Deler",
  "confirmations.delete.message": "Es tu secur que tu vole deler iste message?",
  "confirmations.delete.title": "Deler message?",
  "confirmations.delete_list.confirm": "Deler",
  "confirmations.delete_list.message": "Es tu secur que tu vole deler permanentemente iste lista?",
  "confirmations.delete_list.title": "Deler lista?",
  "confirmations.discard_draft.confirm": "Discartar e continuar",
  "confirmations.discard_draft.edit.cancel": "Reprender le modification",
  "confirmations.discard_draft.edit.message": "Si tu continua, tu perdera tote le modificatione que tu ha apportate al message que tu modifica in iste momento.",
  "confirmations.discard_draft.edit.title": "Discartar le modificationes de tu message?",
  "confirmations.discard_draft.post.cancel": "Retornar al esbosso",
  "confirmations.discard_draft.post.message": "Si tu continua, tu perdera le message que tu compone in iste momento.",
  "confirmations.discard_draft.post.title": "Discartar tu esbosso de message?",
  "confirmations.discard_edit_media.confirm": "Abandonar",
  "confirmations.discard_edit_media.message": "Tu ha cambiamentos non salvate in le description o previsualisation del objecto multimedial. Abandonar los?",
  "confirmations.follow_to_list.confirm": "Sequer e adder al lista",
  "confirmations.follow_to_list.message": "Tu debe sequer {name} pro poter adder le/la a un lista.",
  "confirmations.follow_to_list.title": "Sequer le usator?",
  "confirmations.logout.confirm": "Clauder session",
  "confirmations.logout.message": "Es tu secur que tu vole clauder le session?",
  "confirmations.logout.title": "Clauder session?",
  "confirmations.missing_alt_text.confirm": "Adder texto alternative",
  "confirmations.missing_alt_text.message": "Tu message contine multimedia sin texto alternative. Adder descriptiones adjuta a render tu contento accessibile a plus personas.",
  "confirmations.missing_alt_text.secondary": "Publicar totevia",
  "confirmations.missing_alt_text.title": "Adder texto alternative?",
  "confirmations.mute.confirm": "Silentiar",
  "confirmations.private_quote_notify.cancel": "Retornar al modification",
  "confirmations.private_quote_notify.confirm": "Publicar message",
  "confirmations.private_quote_notify.do_not_show_again": "Non monstrar me iste message de novo",
  "confirmations.private_quote_notify.message": "Le persona que tu cita e altere personas mentionate recipera un notification e potera vider tu message, etiam si illes non te seque.",
  "confirmations.private_quote_notify.title": "Compartir on sequitores e usatores mentionate?",
  "confirmations.quiet_post_quote_info.dismiss": "Non rememorar me de novo",
  "confirmations.quiet_post_quote_info.got_it": "Comprendite",
  "confirmations.quiet_post_quote_info.message": "Quando tu cita un message public quiete, tu message non apparera in le chronologias de tendentias.",
  "confirmations.quiet_post_quote_info.title": "Citation de messages public quiete",
  "confirmations.redraft.confirm": "Deler e rescriber",
  "confirmations.redraft.message": "Es tu secur de voler deler iste message e rescriber lo? Le favorites e le impulsos essera perdite, e le responsas al message original essera orphanate.",
  "confirmations.redraft.title": "Deler e rescriber le message?",
  "confirmations.remove_from_followers.confirm": "Remover sequitor",
  "confirmations.remove_from_followers.message": "{name} non plus te sequera. Es tu secur de voler continuar?",
  "confirmations.remove_from_followers.title": "Remover sequitor?",
  "confirmations.revoke_quote.confirm": "Remover message",
  "confirmations.revoke_quote.message": "Iste action non pote esser disfacite.",
  "confirmations.revoke_quote.title": "Remover message?",
  "confirmations.unblock.confirm": "Disblocar",
  "confirmations.unblock.title": "Disblocar {name}?",
  "confirmations.unfollow.confirm": "Non plus sequer",
  "confirmations.unfollow.title": "Cessar de sequer {name}?",
  "confirmations.withdraw_request.confirm": "Retirar requesta",
  "confirmations.withdraw_request.title": "Retirar le requesta de sequer {name}?",
  "content_warning.hide": "Celar le message",
  "content_warning.show": "Monstrar in omne caso",
  "content_warning.show_more": "Monstrar plus",
  "conversation.delete": "Deler conversation",
  "conversation.mark_as_read": "Marcar como legite",
  "conversation.open": "Vider conversation",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiate al area de transferentia",
  "copypaste.copied": "Copiate",
  "copypaste.copy_to_clipboard": "Copiar al area de transferentia",
  "directory.federated": "Ab le fediverso cognoscite",
  "directory.local": "Solmente ab {domain}",
  "directory.new_arrivals": "Nove arrivatas",
  "directory.recently_active": "Recentemente active",
  "disabled_account_banner.account_settings": "Parametros de conto",
  "disabled_account_banner.text": "Tu conto {disabledAccount} es actualmente disactivate.",
  "dismissable_banner.community_timeline": "Ecce le messages public le plus recente del personas con contos sur {domain}.",
  "dismissable_banner.dismiss": "Clauder",
  "dismissable_banner.public_timeline": "Istes es le messages public le plus recente del personas sur le fediverso que le gente sur {domain} seque.",
  "domain_block_modal.block": "Blocar le servitor",
  "domain_block_modal.block_account_instead": "Blocar @{name} in su loco",
  "domain_block_modal.they_can_interact_with_old_posts": "Le personas de iste servitor pote interager con tu messages ancian.",
  "domain_block_modal.they_cant_follow": "Necuno de iste servitor pote sequer te.",
  "domain_block_modal.they_wont_know": "Ille non sapera que ille ha essite blocate.",
  "domain_block_modal.title": "Blocar dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Tu perdera {followersCount, plural, one {{followersCountDisplay} sequitor} other {{followersCountDisplay} sequitores}} e {followingCount, plural, one {{followingCountDisplay} persona que tu seque} other {{followingCountDisplay} personas que tu seque}}.",
  "domain_block_modal.you_will_lose_relationships": "Tu perdera tote le sequitores e personas que tu seque de iste servitor.",
  "domain_block_modal.you_wont_see_posts": "Tu non videra messages e notificationes de usatores sur iste servitor.",
  "domain_pill.activitypub_lets_connect": "Illo te permitte connecter e interager con personas non solmente sur Mastodon, ma tamben sur altere applicationes social.",
  "domain_pill.activitypub_like_language": "ActivityPub es le linguage commun que Mastodon parla con altere retes social.",
  "domain_pill.server": "Servitor",
  "domain_pill.their_handle": "Su pseudonymo:",
  "domain_pill.their_server": "Su casa digital, ubi vive tote su messages.",
  "domain_pill.their_username": "Su identificator unic sur su servitor. Es possibile trovar usatores con le mesme nomine de usator sur servitores differente.",
  "domain_pill.username": "Nomine de usator",
  "domain_pill.whats_in_a_handle": "Que significa un pseudonymo?",
  "domain_pill.who_they_are": "Un pseudonymo indica qui un persona es e ubi se trova, de maniera que tu pote interager con personas sur tote le rete social de <button>platteformas basate sur ActivityPub</button>.",
  "domain_pill.who_you_are": "Perque tu pseudonymo indica qui tu es e ubi tu te trova, le gente pote interager con te desde tote le rete social de <button>platteformas basate sur ActivityPub</button>.",
  "domain_pill.your_handle": "Tu pseudonymo:",
  "domain_pill.your_server": "Tu casa digital, ubi vive tote tu messages. Non te place? Cambia de servitor a omne momento e porta tu sequitores con te.",
  "domain_pill.your_username": "Tu identificator unic sur iste servitor. Es possibile trovar usatores con le mesme nomine de usator sur servitores differente.",
  "dropdown.empty": "Selige un option",
  "embed.instructions": "Incorpora iste message sur tu sito web con le codice sequente.",
  "embed.preview": "Ecce como illlo parera:",
  "emoji_button.activity": "Activitate",
  "emoji_button.clear": "Rader",
  "emoji_button.custom": "Personalisate",
  "emoji_button.flags": "Bandieras",
  "emoji_button.food": "Alimentos e bibitas",
  "emoji_button.label": "Inserer emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Necun emoji correspondente trovate",
  "emoji_button.objects": "Objectos",
  "emoji_button.people": "Personas",
  "emoji_button.recent": "Frequentemente usate",
  "emoji_button.search": "Cercar...",
  "emoji_button.search_results": "Resultatos de recerca",
  "emoji_button.symbols": "Symbolos",
  "emoji_button.travel": "Viages e locos",
  "empty_column.account_hides_collections": "Le usator non ha rendite iste information disponibile",
  "empty_column.account_suspended": "Conto suspendite",
  "empty_column.account_timeline": "Nulle messages hic!",
  "empty_column.account_unavailable": "Profilo non disponibile",
  "empty_column.blocks": "Tu non ha blocate alcun usator ancora.",
  "empty_column.bookmarked_statuses": "Tu non ha ancora messages in marcapaginas. Quando tu adde un message al marcapaginas, illo apparera hic.",
  "empty_column.community": "Le chronologia local es vacue. Scribe qualcosa public pro poner le cosas in marcha!",
  "empty_column.direct": "Tu non ha ancora mentiones private. Quando tu invia o recipe un mention, illo apparera hic.",
  "empty_column.disabled_feed": "Iste fluxo ha essite disactivate per le administratores de tu servitor.",
  "empty_column.domain_blocks": "Il non ha dominios blocate ancora.",
  "empty_column.explore_statuses": "Il non ha tendentias in iste momento. Reveni plus tarde!",
  "empty_column.favourited_statuses": "Tu non ha alcun message favorite ancora. Quando tu marca un message como favorite, illo apparera hic.",
  "empty_column.favourites": "Necuno ha ancora marcate iste message como favorite. Quando alcuno lo face, ille apparera hic.",
  "empty_column.follow_requests": "Tu non ha ancora requestas de sequimento. Quando tu recipe un, illo apparera hic.",
  "empty_column.followed_tags": "Tu non seque ancora alcun hashtags. Quando tu lo face, illos apparera hic.",
  "empty_column.hashtag": "Il non ha ancora alcun cosa in iste hashtag.",
  "empty_column.home": "Tu chronologia de initio es vacue! Seque plus personas pro plenar lo.",
  "empty_column.list": "Iste lista es ancora vacue. Quando le membros de iste lista publica nove messages, illos apparera hic.",
  "empty_column.mutes": "Tu non ha ancora silentiate alcun usator.",
  "empty_column.notification_requests": "Iste lista es toto vacue! Quando tu recipe notificationes, illos apparera hic como configurate in tu parametros.",
  "empty_column.notifications": "Tu non ha ancora notificationes. Quando altere personas interage con te, tu lo videra hic.",
  "empty_column.public": "Il ha nihil hic! Scribe qualcosa public, o manualmente seque usatores de altere servitores, pro plenar lo",
  "error.no_hashtag_feed_access": "Inscribe te o aperi session pro vider e sequer iste hashtag.",
  "error.unexpected_crash.explanation": "A causa de un defecto in nostre codice o de un problema de compatibilitate del navigator, iste pagina non pote esser visualisate correctemente.",
  "error.unexpected_crash.explanation_addons": "Iste pagina non pote esser visualisate correctemente. Iste error es probabilemente causate per un additivo al navigator o per un utensile de traduction automatic.",
  "error.unexpected_crash.next_steps": "Tenta refrescar le pagina. Si isto non remedia le problema, es possibile que tu pote totevia usar Mastodon per medio de un altere navigator o application native.",
  "error.unexpected_crash.next_steps_addons": "Tenta disactivar istes e refrescar le pagina. Si isto non remedia le problema, es possibile que tu pote totevia usar Mastodon per medio de un altere navigator o application native.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar le traciamento del pila al area de transferentia",
  "errors.unexpected_crash.report_issue": "Reportar problema",
  "explore.suggested_follows": "Personas",
  "explore.title": "In tendentia",
  "explore.trending_links": "Novas",
  "explore.trending_statuses": "Messages",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Message</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Message fixate} other {Messages fixate}}",
  "featured_carousel.slide": "Message {current, number} de {max, number}",
  "filter_modal.added.context_mismatch_explanation": "Iste categoria de filtros non se applica al contexto in le qual tu ha accedite a iste message. Pro filtrar le message in iste contexto tamben, modifica le filtro.",
  "filter_modal.added.context_mismatch_title": "Contexto incoherente!",
  "filter_modal.added.expired_explanation": "Iste categoria de filtros ha expirate. Tu debe modificar le data de expiration pro applicar lo.",
  "filter_modal.added.expired_title": "Filtro expirate!",
  "filter_modal.added.review_and_configure": "Pro revider e configurar ulteriormente iste categoria de filtros, visita le {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Parametros de filtro",
  "filter_modal.added.settings_link": "pagina de parametros",
  "filter_modal.added.short_explanation": "Iste message ha essite addite al sequente categoria de filtros: {title}.",
  "filter_modal.added.title": "Filtro addite!",
  "filter_modal.select_filter.context_mismatch": "non se applica a iste contexto",
  "filter_modal.select_filter.expired": "expirate",
  "filter_modal.select_filter.prompt_new": "Nove categoria: {name}",
  "filter_modal.select_filter.search": "Cercar o crear",
  "filter_modal.select_filter.subtitle": "Usa un categoria existente o crea un nove",
  "filter_modal.select_filter.title": "Filtrar iste message",
  "filter_modal.title.status": "Filtrar un message",
  "filter_warning.matches_filter": "Corresponde al filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {necuno} one {un persona} other {# personas}} que tu pote cognoscer",
  "filtered_notifications_banner.title": "Notificationes filtrate",
  "firehose.all": "Toto",
  "firehose.local": "Iste servitor",
  "firehose.remote": "Altere servitores",
  "follow_request.authorize": "Autorisar",
  "follow_request.reject": "Rejectar",
  "follow_requests.unlocked_explanation": "Benque tu conto non es serrate, le personal de {domain} pensa que es un bon idea que tu revide manualmente le sequente requestas de iste contos.",
  "follow_suggestions.curated_suggestion": "Selection del equipa",
  "follow_suggestions.dismiss": "Non monstrar de novo",
  "follow_suggestions.featured_longer": "Seligite con cura per le equipa de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular inter le gente que tu seque",
  "follow_suggestions.hints.featured": "Iste profilo ha essite seligite manualmente per le equipa de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Iste profilo es popular inter le gente que tu seque.",
  "follow_suggestions.hints.most_followed": "Iste profilo es un del plus sequites sur {domain}.",
  "follow_suggestions.hints.most_interactions": "Iste profilo ha recentemente recipite multe attention sur {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Iste profilo es similar al profilos que tu ha recentemente comenciate a sequer.",
  "follow_suggestions.personalized_suggestion": "Suggestion personalisate",
  "follow_suggestions.popular_suggestion": "Suggestion personalisate",
  "follow_suggestions.popular_suggestion_longer": "Popular sur {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similar al profilos que tu ha recentemente comenciate a sequer",
  "follow_suggestions.view_all": "Vider toto",
  "follow_suggestions.who_to_follow": "Qui sequer",
  "followed_tags": "Hashtags sequite",
  "footer.about": "A proposito",
  "footer.about_this_server": "A proposito",
  "footer.directory": "Directorio de profilos",
  "footer.get_app": "Obtener le application",
  "footer.keyboard_shortcuts": "Accessos directe de claviero",
  "footer.privacy_policy": "Politica de confidentialitate",
  "footer.source_code": "Vider le codice fonte",
  "footer.status": "Stato",
  "footer.terms_of_service": "Conditiones de servicio",
  "generic.saved": "Salvate",
  "getting_started.heading": "Prime passos",
  "hashtag.admin_moderation": "Aperir le interfacie de moderation pro #{name}",
  "hashtag.browse": "Percurrer messages in #{hashtag}",
  "hashtag.browse_from_account": "Percurrer le messages de @{name} in #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "Nulle suggestiones trovate",
  "hashtag.column_settings.select.placeholder": "Insere hashtags…",
  "hashtag.column_settings.tag_mode.all": "Tote istes",
  "hashtag.column_settings.tag_mode.any": "Un o plus de istes",
  "hashtag.column_settings.tag_mode.none": "Necun de istes",
  "hashtag.column_settings.tag_toggle": "Includer etiquettas additional pro iste columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} message} other {{counter} messages}} hodie",
  "hashtag.feature": "Evidentiar sur le profilo",
  "hashtag.follow": "Sequer hashtag",
  "hashtag.mute": "Silentiar #{hashtag}",
  "hashtag.unfeature": "Non evidentiar sur le profilo",
  "hashtag.unfollow": "Non plus sequer le hashtag",
  "hashtags.and_other": "…e {count, plural, one {un altere} other {# alteres}}",
  "hints.profiles.followers_may_be_missing": "Le sequitores de iste profilo pote mancar.",
  "hints.profiles.follows_may_be_missing": "Le profilos sequite per iste profilo pote mancar.",
  "hints.profiles.posts_may_be_missing": "Alcun messages de iste profilo pote mancar.",
  "hints.profiles.see_more_followers": "Vider plus de sequitores sur {domain}",
  "hints.profiles.see_more_follows": "Vider plus de sequites sur {domain}",
  "hints.profiles.see_more_posts": "Vider plus de messages sur {domain}",
  "home.column_settings.show_quotes": "Monstrar citationes",
  "home.column_settings.show_reblogs": "Monstrar impulsos",
  "home.column_settings.show_replies": "Monstrar responsas",
  "home.hide_announcements": "Celar annuncios",
  "home.pending_critical_update.body": "Actualisa tu servitor de Mastodon le plus tosto possibile!",
  "home.pending_critical_update.link": "Vider actualisationes",
  "home.pending_critical_update.title": "Actualisation de securitate critic disponibile!",
  "home.show_announcements": "Monstrar annuncios",
  "ignore_notifications_modal.disclaimer": "Mastodon non pote informar al usatores que tu ha ignorate lor notificationes. Ignorar le notificationes non impedira le invio del messages.",
  "ignore_notifications_modal.filter_instead": "Filtrar in vice",
  "ignore_notifications_modal.filter_to_act_users": "Tu ancora potera acceptar, rejectar, o reportar usatores",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrar adjuta a evitar confusion potential",
  "ignore_notifications_modal.filter_to_review_separately": "Tu pote revider separatemente le notificationes filtrate",
  "ignore_notifications_modal.ignore": "Ignorar le notificationes",
  "ignore_notifications_modal.limited_accounts_title": "Ignorar le notificationes de contos moderate?",
  "ignore_notifications_modal.new_accounts_title": "Ignorar le notificationes de nove contos?",
  "ignore_notifications_modal.not_followers_title": "Ignorar notificationes de personas qui non te seque?",
  "ignore_notifications_modal.not_following_title": "Ignorar notificationes de personas que tu non seque?",
  "ignore_notifications_modal.private_mentions_title": "Ignorar notificationes de mentiones private non requestate?",
  "info_button.label": "Adjuta",
  "info_button.what_is_alt_text": "<h1>Que es texto alternative?</h1><p>Le texto alternative forni descriptiones de imagines a personas con impedimentos visual, con connexiones lente a internet, o qui cerca contexto supplementari.</p><p>Tu pote meliorar le accessibilitate e le comprension pro totes si tu scribe un texto alternative clar, concise e objective.</p><ul><li>Captura le elementos importante</li><li>Summarisa texto in imagines</li><li>Usa un structura conventional de phrases</li><li>Evita information redundante</li><li>In figuras complexe (como diagrammas o mappas), concentra te sur le tendentias e punctos clave</li></ul>",
  "interaction_modal.action": "Pro interager con le message de {name}, tu debe acceder a tu conto sur le servitor Mastodon que tu usa.",
  "interaction_modal.go": "Revenir",
  "interaction_modal.no_account_yet": "Tu non ha ancora un conto?",
  "interaction_modal.on_another_server": "Sur un altere servitor",
  "interaction_modal.on_this_server": "Sur iste servitor",
  "interaction_modal.title": "Aperi session pro continuar",
  "interaction_modal.username_prompt": "P.ex. {example}",
  "intervals.full.days": "{number, plural, one {# die} other {# dies}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} other {# minutas}}",
  "keyboard_shortcuts.back": "Navigar retro",
  "keyboard_shortcuts.blocked": "Aperir lista de usatores blocate",
  "keyboard_shortcuts.boost": "Impulsar le message",
  "keyboard_shortcuts.column": "Focalisar al columna",
  "keyboard_shortcuts.compose": "Focalisar al area de composition de texto",
  "keyboard_shortcuts.description": "Description",
  "keyboard_shortcuts.down": "Displaciar a basso in le lista",
  "keyboard_shortcuts.enter": "Aperir message",
  "keyboard_shortcuts.favourite": "Message favorite",
  "keyboard_shortcuts.favourites": "Aperir lista de favoritos",
  "keyboard_shortcuts.federated": "Aperir le chronologia federate",
  "keyboard_shortcuts.heading": "Accessos directe de claviero",
  "keyboard_shortcuts.home": "Aperir le chronologia de initio",
  "keyboard_shortcuts.hotkey": "Clave accelerator",
  "keyboard_shortcuts.legend": "Monstrar iste legenda",
  "keyboard_shortcuts.load_more": "Focalisar le button “Cargar plus”",
  "keyboard_shortcuts.local": "Aperir le chronologia local",
  "keyboard_shortcuts.mention": "Mentionar le autor",
  "keyboard_shortcuts.muted": "Aperir lista de usatores silentiate",
  "keyboard_shortcuts.my_profile": "Aperir tu profilo",
  "keyboard_shortcuts.notifications": "Aperir columna de notificationes",
  "keyboard_shortcuts.open_media": "Aperir multimedia",
  "keyboard_shortcuts.pinned": "Aperir le lista de messages fixate",
  "keyboard_shortcuts.profile": "Aperir le profilo del autor",
  "keyboard_shortcuts.quote": "Citar message",
  "keyboard_shortcuts.reply": "Responder al message",
  "keyboard_shortcuts.requests": "Aperir le lista de requestas de sequimento",
  "keyboard_shortcuts.search": "Focalisar barra de recerca",
  "keyboard_shortcuts.spoilers": "Monstrar/celar le campo CW",
  "keyboard_shortcuts.start": "Aperir columna “comenciar”",
  "keyboard_shortcuts.toggle_hidden": "Monstrar/celar texto detra advertimento de contento",
  "keyboard_shortcuts.toggle_sensitivity": "Monstrar/celar multimedia",
  "keyboard_shortcuts.toot": "Initiar un nove message",
  "keyboard_shortcuts.translate": "a traducer un message",
  "keyboard_shortcuts.unfocus": "Disfocalisar le area de composition de texto/de recerca",
  "keyboard_shortcuts.up": "Displaciar in alto in le lista",
  "learn_more_link.got_it": "Comprendite",
  "learn_more_link.learn_more": "Pro saper plus",
  "lightbox.close": "Clauder",
  "lightbox.next": "Sequente",
  "lightbox.previous": "Precedente",
  "lightbox.zoom_in": "Aggrandir al dimension real",
  "lightbox.zoom_out": "Diminuer pro adaptar",
  "limited_account_hint.action": "Monstrar profilo in omne caso",
  "limited_account_hint.title": "Iste profilo ha essite celate per le moderatores de {domain}.",
  "link_preview.author": "Per {name}",
  "link_preview.more_from_author": "Plus de {name}",
  "link_preview.shares": "{count, plural, one {{counter} message} other {{counter} messages}}",
  "lists.add_member": "Adder",
  "lists.add_to_list": "Adder al lista",
  "lists.add_to_lists": "Adder {name} al listas",
  "lists.create": "Crear",
  "lists.create_a_list_to_organize": "Crear un nove lista pro organisar tu fluxo de initio",
  "lists.create_list": "Crear lista",
  "lists.delete": "Deler lista",
  "lists.done": "Facite",
  "lists.edit": "Modificar lista",
  "lists.exclusive": "Celar memberos in Initio",
  "lists.exclusive_hint": "Si alcuno es sur iste lista, celar iste persona in tu fluxo de initio pro evitar de vider su messages duo vices.",
  "lists.find_users_to_add": "Trovar usatores a adder",
  "lists.list_members_count": "{count, plural, one {# membro} other {# membros}}",
  "lists.list_name": "Nomine del lista",
  "lists.new_list_name": "Nove nomine de lista",
  "lists.no_lists_yet": "Necun lista ancora.",
  "lists.no_members_yet": "Necun membro ancora.",
  "lists.no_results_found": "Necun resultato trovate.",
  "lists.remove_member": "Remover",
  "lists.replies_policy.followed": "Qualcunque usator sequite",
  "lists.replies_policy.list": "Membros del lista",
  "lists.replies_policy.none": "Nemo",
  "lists.save": "Salvar",
  "lists.search": "Cercar",
  "lists.show_replies_to": "Includer responsas de membros del lista a",
  "load_pending": "{count, plural, one {# nove entrata} other {# nove entratas}}",
  "loading_indicator.label": "Cargante…",
  "media_gallery.hide": "Celar",
  "moved_to_account_banner.text": "Tu conto {disabledAccount} es actualmente disactivate perque tu ha cambiate de conto a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Celar in notificationes",
  "mute_modal.hide_options": "Celar optiones",
  "mute_modal.indefinite": "Usque io dissilentia iste persona",
  "mute_modal.show_options": "Monstrar optiones",
  "mute_modal.they_can_mention_and_follow": "Ille pote mentionar te e sequer te, ma tu non potera vider le.",
  "mute_modal.they_wont_know": "Ille non sapera que ille ha essite silentiate.",
  "mute_modal.title": "Silentiar le usator?",
  "mute_modal.you_wont_see_mentions": "Tu non videra le messages que mentiona iste persona.",
  "mute_modal.you_wont_see_posts": "Iste persona pote totevia vider tu messages, ma tu non videra le sues.",
  "navigation_bar.about": "A proposito",
  "navigation_bar.account_settings": "Contrasigno e securitate",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Aperir in le interfacie web avantiate",
  "navigation_bar.automated_deletion": "Deletion automatic del message",
  "navigation_bar.blocks": "Usatores blocate",
  "navigation_bar.bookmarks": "Marcapaginas",
  "navigation_bar.direct": "Mentiones private",
  "navigation_bar.domain_blocks": "Dominios blocate",
  "navigation_bar.favourites": "Favorites",
  "navigation_bar.filters": "Parolas silentiate",
  "navigation_bar.follow_requests": "Requestas de sequimento",
  "navigation_bar.followed_tags": "Hashtags sequite",
  "navigation_bar.follows_and_followers": "Sequites e sequitores",
  "navigation_bar.import_export": "Importar e exportar",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Fluxo in vivo (local)",
  "navigation_bar.live_feed_public": "Fluxo in vivo (public)",
  "navigation_bar.logout": "Clauder session",
  "navigation_bar.moderation": "Moderation",
  "navigation_bar.more": "Plus",
  "navigation_bar.mutes": "Usatores silentiate",
  "navigation_bar.opened_in_classic_interface": "Messages, contos e altere paginas specific es aperite per predefinition in le interfacie web classic.",
  "navigation_bar.preferences": "Preferentias",
  "navigation_bar.privacy_and_reach": "Confidentialitate e portata",
  "navigation_bar.search": "Cercar",
  "navigation_bar.search_trends": "Cercar / In tendentia",
  "navigation_panel.collapse_followed_tags": "Contraher le menu de hashtags sequite",
  "navigation_panel.collapse_lists": "Contraher le menu de listas",
  "navigation_panel.expand_followed_tags": "Expander le menu de hashtags sequite",
  "navigation_panel.expand_lists": "Expander le menu de listas",
  "not_signed_in_indicator.not_signed_in": "Es necessari aperir session pro acceder a iste ressource.",
  "notification.admin.report": "{name} ha reportate {target}",
  "notification.admin.report_account": "{name} ha reportate {count, plural, one {un message} other {# messages}} de {target} per {category}",
  "notification.admin.report_account_other": "{name} ha reportate {count, plural, one {un message} other {# messages}} de {target}",
  "notification.admin.report_statuses": "{name} ha reportate {target} pro {category}",
  "notification.admin.report_statuses_other": "{name} ha reportate {target}",
  "notification.admin.sign_up": "{name} se ha inscribite",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural, one {# altere persona} other {# altere personas}} se ha inscribite",
  "notification.annual_report.message": "Tu summario #Wrapstodon pro {year} attende! Revela le momentos saliente e memorabile de tu anno sur Mastodon!",
  "notification.annual_report.view": "Visitar summario #Wrapstodon",
  "notification.favourite": "{name} ha marcate tu message como favorite",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {# altere} other {# alteres}}</a> ha marcate tu message como favorite",
  "notification.favourite_pm": "{name} ha marcate tu mention privte como favorite",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural, one {# altere} other {# alteres}}</a> ha marcate tu mention private como favorite",
  "notification.follow": "{name} te seque",
  "notification.follow.name_and_others": "{name} e <a>{count, plural, one {# other} other {# alteres}}</a> te seque",
  "notification.follow_request": "{name} ha requestate de sequer te",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {# altere} other {# alteres}} ha demandate de sequer te",
  "notification.label.mention": "Mention",
  "notification.label.private_mention": "Mention private",
  "notification.label.private_reply": "Responsa private",
  "notification.label.quote": "{name} ha citate tu message",
  "notification.label.reply": "Responder",
  "notification.mention": "Mention",
  "notification.mentioned_you": "{name} te ha mentionate",
  "notification.moderation-warning.learn_more": "Apprender plus",
  "notification.moderation_warning": "Tu ha recipite un advertimento de moderation",
  "notification.moderation_warning.action_delete_statuses": "Alcunes de tu messages ha essite removite.",
  "notification.moderation_warning.action_disable": "Tu conto ha essite disactivate.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Alcunes de tu messages ha essite marcate como sensibile.",
  "notification.moderation_warning.action_none": "Tu conto ha recipite un advertimento de moderation.",
  "notification.moderation_warning.action_sensitive": "Tu messages essera marcate como sensibile a partir de ora.",
  "notification.moderation_warning.action_silence": "Tu conto ha essite limitate.",
  "notification.moderation_warning.action_suspend": "Tu conto ha essite suspendite.",
  "notification.own_poll": "Tu sondage ha finite",
  "notification.poll": "Un sondage in le qual tu ha votate ha finite",
  "notification.quoted_update": "{name} ha modificate un message que tu ha citate",
  "notification.reblog": "{name} ha impulsate tu message",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural, one {# altere} other {# alteres}}</a> ha impulsate tu message",
  "notification.relationships_severance_event": "Connexiones perdite con {name}",
  "notification.relationships_severance_event.account_suspension": "Un administrator de {from} ha suspendiute {target}. Isto significa que tu non pote plus reciper actualisationes de iste persona o interager con ille.",
  "notification.relationships_severance_event.domain_block": "Un administrator de {from} ha blocate {target}, includente {followersCount} de tu sequitores e {followingCount, plural, one {# conto} other {# contos}} que tu seque.",
  "notification.relationships_severance_event.learn_more": "Apprender plus",
  "notification.relationships_severance_event.user_domain_block": "Tu ha blocate {target}, assi removente {followersCount} de tu sequitores e {followingCount, plural, one {# conto} other {# contos}} que tu seque.",
  "notification.status": "{name} ha justo ora publicate",
  "notification.update": "{name} ha modificate un message",
  "notification_requests.accept": "Acceptar",
  "notification_requests.accept_multiple": "{count, plural, one {Acceptar # requesta…} other {Acceptar # requestas…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Acceptar le requesta} other {Acceptar le requestas}}",
  "notification_requests.confirm_accept_multiple.message": "Tu es sur le puncto de acceptar {count, plural, one {un requesta de notification} other {# requestas de notification}}. Es tu secur de voler continuar?",
  "notification_requests.confirm_accept_multiple.title": "Acceptar petitiones de notification?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Rejectar le requesta} other {Rejectar le requestas}}",
  "notification_requests.confirm_dismiss_multiple.message": "Tu es sur le puncto de rejectar {count, plural, one {un requesta} other {# requestas}} de notification. Tu non potera facilemente acceder a {count, plural, one {illo} other {illos}} plus tarde. Es tu secur de voler continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "Dimitter petitiones de notification?",
  "notification_requests.dismiss": "Clauder",
  "notification_requests.dismiss_multiple": "{count, plural, one {Rejectar # requesta…} other {Rejectar # requestas…}}",
  "notification_requests.edit_selection": "Modificar",
  "notification_requests.exit_selection": "Facite",
  "notification_requests.explainer_for_limited_account": "Le notificationes de iste conto ha essite filtrate perque le conto ha essite limitate per un moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Le notificationes de iste conto ha essite filtrate perque le conto o su servitor ha essite limitate per un moderator.",
  "notification_requests.maximize": "Maximisar",
  "notification_requests.minimize_banner": "Minimisar le bandiera de notificationes filtrate",
  "notification_requests.notifications_from": "Notificationes de {name}",
  "notification_requests.title": "Notificationes filtrate",
  "notification_requests.view": "Vider notificationes",
  "notifications.clear": "Rader notificationes",
  "notifications.clear_confirmation": "Es tu secur que tu vole rader permanentemente tote tu notificationes?",
  "notifications.clear_title": "Rader le notificationes?",
  "notifications.column_settings.admin.report": "Nove reportos:",
  "notifications.column_settings.admin.sign_up": "Nove inscriptiones:",
  "notifications.column_settings.alert": "Notificationes de scriptorio",
  "notifications.column_settings.favourite": "Favorites:",
  "notifications.column_settings.filter_bar.advanced": "Monstrar tote le categorias",
  "notifications.column_settings.filter_bar.category": "Barra de filtro rapide",
  "notifications.column_settings.follow": "Nove sequitores:",
  "notifications.column_settings.follow_request": "Nove requestas de sequimento:",
  "notifications.column_settings.group": "Gruppo",
  "notifications.column_settings.mention": "Mentiones:",
  "notifications.column_settings.poll": "Resultatos del sondage:",
  "notifications.column_settings.push": "Notificationes push",
  "notifications.column_settings.quote": "Citationes:",
  "notifications.column_settings.reblog": "Impulsos:",
  "notifications.column_settings.show": "Monstrar in columna",
  "notifications.column_settings.sound": "Reproducer sono",
  "notifications.column_settings.status": "Nove messages:",
  "notifications.column_settings.unread_notifications.category": "Notificationes non legite",
  "notifications.column_settings.unread_notifications.highlight": "Marcar le notificationes non legite",
  "notifications.column_settings.update": "Modificationes:",
  "notifications.filter.all": "Toto",
  "notifications.filter.boosts": "Impulsos",
  "notifications.filter.favourites": "Favorites",
  "notifications.filter.follows": "Sequites",
  "notifications.filter.mentions": "Mentiones",
  "notifications.filter.polls": "Resultatos del sondage",
  "notifications.filter.statuses": "Actualisationes de personas que tu seque",
  "notifications.grant_permission": "Conceder permission.",
  "notifications.group": "{count} notificationes",
  "notifications.mark_as_read": "Marcar cata notification como legite",
  "notifications.permission_denied": "Le notificationes de scriptorio es indisponibile a causa de un requesta anteriormente refusate de permissiones del navigator",
  "notifications.permission_denied_alert": "Le notificationes de scriptorio non pote esser activate perque le permission del navigator ha essite refusate anteriormente",
  "notifications.permission_required": "Le notificationes de scriptorio es indisponibile perque le permission necessari non ha essite concedite.",
  "notifications.policy.accept": "Acceptar",
  "notifications.policy.accept_hint": "Monstrar in le notificationes",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Inviar al vacuo, pro non esser jammais plus vidite",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_hint": "Inviar al cassa de notificationes filtrate",
  "notifications.policy.filter_limited_accounts_hint": "Limitate per le moderatores del servitor",
  "notifications.policy.filter_limited_accounts_title": "Contos moderate",
  "notifications.policy.filter_new_accounts.hint": "Create in le ultime {days, plural, one {die} other {# dies}}",
  "notifications.policy.filter_new_accounts_title": "Nove contos",
  "notifications.policy.filter_not_followers_hint": "Includente le personas que te seque desde minus de {days, plural, one {un die} other {# dies}}",
  "notifications.policy.filter_not_followers_title": "Personas qui non te seque",
  "notifications.policy.filter_not_following_hint": "Usque tu les approba manualmente",
  "notifications.policy.filter_not_following_title": "Personas que tu non seque",
  "notifications.policy.filter_private_mentions_hint": "Filtrate, excepte si es in responsa a tu proprie mention o si tu seque le expeditor",
  "notifications.policy.filter_private_mentions_title": "Mentiones private indesirate",
  "notifications.policy.title": "Gerer notificationes de…",
  "notifications_permission_banner.enable": "Activar notificationes de scriptorio",
  "notifications_permission_banner.how_to_control": "Pro reciper notificationes quando Mastodon non es aperte, activa le notificationes de scriptorio. Post lor activation, es possibile controlar precisemente qual typos de interaction genera notificationes de scriptorio per medio del button {icon} hic supra.",
  "notifications_permission_banner.title": "Non mancar jammais a un cosa",
  "onboarding.follows.back": "Retro",
  "onboarding.follows.empty": "Regrettabilemente, non es possibile monstrar resultatos al momento. Tu pote tentar usar le recerca o percurrer le pagina de exploration pro cercar personas a sequer, o tentar lo de novo plus tarde.",
  "onboarding.follows.search": "Cercar",
  "onboarding.follows.title": "Seque personas pro comenciar",
  "onboarding.profile.discoverable": "Render mi profilo discoperibile",
  "onboarding.profile.discoverable_hint": "Quando tu opta pro devenir discoperibile sur Mastodon, tu messages pote apparer in resultatos de recerca e in tendentias, e tu profilo pote esser suggerite al personas con interesses simile al tues.",
  "onboarding.profile.display_name": "Nomine a monstrar",
  "onboarding.profile.display_name_hint": "Tu nomine complete o tu supernomine…",
  "onboarding.profile.note": "Bio",
  "onboarding.profile.note_hint": "Tu pote @mentionar altere personas o #hashtags…",
  "onboarding.profile.title": "Configuration del profilo",
  "onboarding.profile.upload_avatar": "Incargar imagine de profilo",
  "onboarding.profile.upload_header": "Actualisar capite de profilo",
  "password_confirmation.exceeds_maxlength": "Le confirmation del contrasigno excede le longitude maxime del contrasigno",
  "password_confirmation.mismatching": "Le confirmation del contrasigno non corresponde",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Claudite",
  "poll.refresh": "Refrescar",
  "poll.reveal": "Vider le resultatos",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Tu ha votate pro iste responsa",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Adder un sondage",
  "poll_button.remove_poll": "Remover un sondage",
  "privacy.change": "Cambiar le confidentialitate del message",
  "privacy.direct.long": "Tote le personas mentionate in le message",
  "privacy.direct.short": "Mention private",
  "privacy.private.long": "Solmente tu sequitores",
  "privacy.private.short": "Sequitores",
  "privacy.public.long": "Quicunque, sur Mastodon o non",
  "privacy.public.short": "Public",
  "privacy.quote.disabled": "{visibility}, citation disactivate",
  "privacy.quote.limited": "{visibility}, citation limitate",
  "privacy.unlisted.additional": "Isto es exactemente como public, excepte que le message non apparera in fluxos in vivo, in hashtags, in Explorar, o in le recerca de Mastodon, mesmo si tu ha optate pro render tote le conto discoperibile.",
  "privacy.unlisted.long": "Non apparera in le resultatos de recerca, tendentias e chronologias public de Mastodon",
  "privacy.unlisted.short": "Public, non listate",
  "privacy_policy.last_updated": "Ultime actualisation {date}",
  "privacy_policy.title": "Politica de confidentialitate",
  "quote_error.edit": "Non es possibile adder citationes quando se modifica un message.",
  "quote_error.poll": "Non es permittite citar sondages.",
  "quote_error.private_mentions": "Non es permittite citar con mentiones directe.",
  "quote_error.quote": "Solmente un citation al vice es permittite.",
  "quote_error.unauthorized": "Tu non es autorisate a citar iste message.",
  "quote_error.upload": "Non es permittite citar con annexos multimedial.",
  "recommended": "Recommendate",
  "refresh": "Refrescar",
  "regeneration_indicator.please_stand_by": "Un momento, per favor.",
  "regeneration_indicator.preparing_your_home_feed": "Fluxo de initio in preparation…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# die} other {# dies}} retro",
  "relative_time.full.hours": "{number, plural, one {# hora} other {# horas}} retro",
  "relative_time.full.just_now": "justo ora",
  "relative_time.full.minutes": "{number, plural, one {# minuta} other {# minutas}} retro",
  "relative_time.full.seconds": "{number, plural, one {# secunda} other {# secundas}} retro",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "ora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hodie",
  "remove_quote_hint.button_label": "Comprendite",
  "remove_quote_hint.message": "Tu pote facer lo desde le menu de optiones {icon}.",
  "remove_quote_hint.title": "Vole remover tu message citate?",
  "reply_indicator.attachments": "{count, plural, one {# annexo} other {# annexos}}",
  "reply_indicator.cancel": "Cancellar",
  "reply_indicator.poll": "Sondage",
  "report.block": "Blocar",
  "report.block_explanation": "Tu non videra le messages de iste persona. Ille non potera vider tu messages o sequer te. Ille potera saper de esser blocate.",
  "report.categories.legal": "Juridic",
  "report.categories.other": "Alteres",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Le contento viola un o plus regulas del servitor",
  "report.category.subtitle": "Elige le option plus adequate",
  "report.category.title": "Describe le problema con iste {type}",
  "report.category.title_account": "profilo",
  "report.category.title_status": "message",
  "report.close": "Facite",
  "report.comment.title": "Ha il altere cosas que nos deberea saper?",
  "report.forward": "Reinviar a {target}",
  "report.forward_hint": "Le conto es de un altere servitor. Inviar un copia anonymisate del reporto a illo tamben?",
  "report.mute": "Silentiar",
  "report.mute_explanation": "Tu non videra le messages de iste persona. Ille pote totevia sequer te e vider tu messages e non sapera de esser silentiate.",
  "report.next": "Sequente",
  "report.placeholder": "Commentos additional",
  "report.reasons.dislike": "Non me place",
  "report.reasons.dislike_description": "Non es qualcosa que tu vole vider",
  "report.reasons.legal": "Es illegal",
  "report.reasons.legal_description": "Tu crede que viola le lege de tu pais o del pais del servitor",
  "report.reasons.other": "Es altere cosa",
  "report.reasons.other_description": "Le problema non entra in altere categorias",
  "report.reasons.spam": "Es spam",
  "report.reasons.spam_description": "Ligamines malevolente, interaction false, o responsas repetitive",
  "report.reasons.violation": "Viola le regulas del servitor",
  "report.reasons.violation_description": "Tu sape que viola regulas specific",
  "report.rules.subtitle": "Selige tote le responsas appropriate",
  "report.rules.title": "Qual regulas es violate?",
  "report.statuses.subtitle": "Selige tote le responsas appropriate",
  "report.statuses.title": "Existe alcun messages que appoia iste reporto?",
  "report.submit": "Submitter",
  "report.target": "Reportage de {target}",
  "report.thanks.take_action": "Ecce tu optiones pro controlar lo que tu vide sur Mastodon:",
  "report.thanks.take_action_actionable": "Durante que nos revide isto, tu pote prender mesuras contra @{name}:",
  "report.thanks.title": "Non vole vider isto?",
  "report.thanks.title_actionable": "Gratias pro reportar, nos investigara isto.",
  "report.unfollow": "Cessar de sequer @{name}",
  "report.unfollow_explanation": "Tu seque iste conto. Pro non plus vider su messages in tu fluxo de initio, cessa de sequer lo.",
  "report_notification.attached_statuses": "{count, plural, one {{count} message} other {{count} messages}} annexate",
  "report_notification.categories.legal": "Juridic",
  "report_notification.categories.legal_sentence": "contento illegal",
  "report_notification.categories.other": "Alteres",
  "report_notification.categories.other_sentence": "alteres",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Violation del regulas",
  "report_notification.categories.violation_sentence": "violation del regulas",
  "report_notification.open": "Aperir reporto",
  "search.clear": "Rader le recerca",
  "search.no_recent_searches": "Nulle recercas recente",
  "search.placeholder": "Cercar",
  "search.quick_action.account_search": "Profilos correspondente a {x}",
  "search.quick_action.go_to_account": "Vader al profilo {x}",
  "search.quick_action.go_to_hashtag": "Vader al hashtag {x}",
  "search.quick_action.open_url": "Aperir URL in Mastodon",
  "search.quick_action.status_search": "Messages correspondente a {x}",
  "search.search_or_paste": "Cerca o colla un URL",
  "search_popout.full_text_search_disabled_message": "Non disponibile sur {domain}.",
  "search_popout.full_text_search_logged_out_message": "Solmente disponibile post aperir session.",
  "search_popout.language_code": "Codice de lingua ISO",
  "search_popout.options": "Optiones de recerca",
  "search_popout.quick_actions": "Actiones rapide",
  "search_popout.recent": "Recercas recente",
  "search_popout.specific_date": "data specific",
  "search_popout.user": "usator",
  "search_results.accounts": "Profilos",
  "search_results.all": "Toto",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Necun resultato.",
  "search_results.no_search_yet": "Tenta cercar messages, profilos o hashtags.",
  "search_results.see_all": "Vider toto",
  "search_results.statuses": "Messages",
  "search_results.title": "Recerca de “{q}”",
  "server_banner.about_active_users": "Personas que ha usate iste servitor in le ultime 30 dies (usatores active per mense)",
  "server_banner.active_users": "usatores active",
  "server_banner.administered_by": "Administrate per:",
  "server_banner.is_one_of_many": "{domain} es un de multe servitores independente de Mastodon que tu pote usar pro participar in le fediverso.",
  "server_banner.server_stats": "Statos del servitor:",
  "sign_in_banner.create_account": "Crear un conto",
  "sign_in_banner.follow_anyone": "Seque quicunque in le fediverso, e tu videra toto in ordine chronologic. Sin algorithmo, sin publicitate, sin titulos de esca.",
  "sign_in_banner.mastodon_is": "Mastodon es le melior maniera de sequer lo que passa.",
  "sign_in_banner.sign_in": "Aperir session",
  "sign_in_banner.sso_redirect": "Aperir session o crear conto",
  "status.admin_account": "Aperir le interfacie de moderation pro @{name}",
  "status.admin_domain": "Aperir le interfacie de moderation pro {domain}",
  "status.admin_status": "Aperir iste message in le interfacie de moderation",
  "status.all_disabled": "Impulso e citation es disactivate",
  "status.block": "Blocar @{name}",
  "status.bookmark": "Adder al marcapaginas",
  "status.cancel_reblog_private": "Disfacer impulso",
  "status.cannot_quote": "Tu non es autorisate a citar iste message",
  "status.cannot_reblog": "Iste message non pote esser impulsate",
  "status.contains_quote": "Contine un citation",
  "status.context.loading": "Cargante plus responsas",
  "status.context.loading_error": "Non poteva cargar nove responsas",
  "status.context.loading_success": "Nove responsas cargate",
  "status.context.more_replies_found": "Plus responsas trovate",
  "status.context.retry": "Tentar de novo",
  "status.context.show": "Monstrar",
  "status.continued_thread": "Continuation del discussion",
  "status.copy": "Copiar ligamine a message",
  "status.delete": "Deler",
  "status.delete.success": "Message delite",
  "status.detailed_status": "Vista detaliate del conversation",
  "status.direct": "Mentionar privatemente @{name}",
  "status.direct_indicator": "Mention private",
  "status.edit": "Modificar",
  "status.edited": "Ultime modification le {date}",
  "status.edited_x_times": "Modificate {count, plural, one {{count} vice} other {{count} vices}}",
  "status.embed": "Obtener codice de incorporation",
  "status.favourite": "Adder al favorites",
  "status.favourites_count": "{count, plural, one {{counter} favorite} other {{counter} favorites}}",
  "status.filter": "Filtrar iste message",
  "status.history.created": "create per {name} le {date}",
  "status.history.edited": "modificate per {name} le {date}",
  "status.load_more": "Cargar plus",
  "status.media.open": "Clicca pro aperir",
  "status.media.show": "Clicca pro monstrar",
  "status.media_hidden": "Contento multimedial celate",
  "status.mention": "Mentionar @{name}",
  "status.more": "Plus",
  "status.mute": "Silentiar @{name}",
  "status.mute_conversation": "Silentiar conversation",
  "status.open": "Expander iste message",
  "status.pin": "Fixar sur profilo",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancellar le citation",
  "status.quote_error.blocked_account_hint.title": "Iste message es celate perque tu ha blocate @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Iste message es celate perque tu ha blocate {domain}.",
  "status.quote_error.filtered": "Celate a causa de un de tu filtros",
  "status.quote_error.limited_account_hint.action": "Monstrar in omne caso",
  "status.quote_error.limited_account_hint.title": "Iste conto ha essite celate per le moderatores de {domain}.",
  "status.quote_error.muted_account_hint.title": "Iste message es celate perque tu ha silentiate @{name}.",
  "status.quote_error.not_available": "Message indisponibile",
  "status.quote_error.pending_approval": "Message pendente",
  "status.quote_error.pending_approval_popout.body": "Sur Mastodon, tu pote controlar si on pote citar te. Iste message attende ora le approbation del autor original.",
  "status.quote_error.revoked": "Message removite per le autor",
  "status.quote_followers_only": "Solmente sequitores pote citar iste message",
  "status.quote_manual_review": "Le autor lo examinara manualmente",
  "status.quote_noun": "Citation",
  "status.quote_policy_change": "Cambiar qui pote citar",
  "status.quote_post_author": "Ha citate un message de @{name}",
  "status.quote_private": "Le messages private non pote esser citate",
  "status.quotes.empty": "Necuno ha ancora citate iste message. Quando alcuno lo face, illo apparera hic.",
  "status.quotes.local_other_disclaimer": "Le citationes rejectate per le autor non essera monstrate.",
  "status.quotes.remote_other_disclaimer": "Solmente le citationes de {domain} se garanti de esser monstrate hic. Citationes rejectate per le autor non essera monstrate.",
  "status.quotes_count": "{count, plural, one {{counter} citation} other {{counter} citationes}}",
  "status.read_more": "Leger plus",
  "status.reblog": "Impulsar",
  "status.reblog_or_quote": "Impulsar o citar",
  "status.reblog_private": "Re-compartir con tu sequitores",
  "status.reblogged_by": "Impulsate per {name}",
  "status.reblogs.empty": "Necuno ha ancora impulsate iste message. Quando alcuno lo face, le impulsos apparera hic.",
  "status.reblogs_count": "{count, plural, one {{counter} impulso} other {{counter} impulsos}}",
  "status.redraft": "Deler e reconciper",
  "status.remove_bookmark": "Remover marcapagina",
  "status.remove_favourite": "Remover del favoritos",
  "status.remove_quote": "Remover",
  "status.replied_in_thread": "Responsa in discussion",
  "status.replied_to": "Responsa a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al discussion",
  "status.report": "Reportar @{name}",
  "status.request_quote": "Demandar a citar",
  "status.revoke_quote": "Remover mi message del message de @{name}",
  "status.sensitive_warning": "Contento sensibile",
  "status.share": "Compartir",
  "status.show_less_all": "Monstrar minus pro totes",
  "status.show_more_all": "Monstrar plus pro totes",
  "status.show_original": "Monstrar original",
  "status.title.with_attachments": "{user} ha publicate {attachmentCount, plural, one {un annexo} other {{attachmentCount} annexos}}",
  "status.translate": "Traducer",
  "status.translated_from_with": "Traducite de {lang} usante {provider}",
  "status.uncached_media_warning": "Previsualisation non disponibile",
  "status.unmute_conversation": "Non plus silentiar conversation",
  "status.unpin": "Disfixar del profilo",
  "subscribed_languages.lead": "Solmente le messages in le linguas seligite apparera in tu chronologias de initio e de listas post le cambiamento. Selige necun pro reciper messages in tote le linguas.",
  "subscribed_languages.save": "Salvar le cambiamentos",
  "subscribed_languages.target": "Cambiar le linguas subscribite pro {target}",
  "tabs_bar.home": "Initio",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notificationes",
  "tabs_bar.publish": "Nove message",
  "tabs_bar.search": "Cercar",
  "terms_of_service.effective_as_of": "In vigor a partir de {date}",
  "terms_of_service.title": "Conditiones de servicio",
  "terms_of_service.upcoming_changes_on": "Cambiamentos a venir le {date}",
  "time_remaining.days": "{number, plural, one {# die} other {# dies}} restante",
  "time_remaining.hours": "{number, plural, one {# hora} other {# horas}} restante",
  "time_remaining.minutes": "{number, plural, one {# minuta} other {# minutas}} restante",
  "time_remaining.moments": "Qualque momentos restante",
  "time_remaining.seconds": "{number, plural, one {# secunda} other {# secundas}} restante",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} in le passate {days, plural, one {die} other {{days} dies}}",
  "trends.trending_now": "Ora in tendentias",
  "ui.beforeunload": "Tu esbosso essera perdite si tu exi de Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Traher e deponer pro incargar",
  "upload_button.label": "Adde imagines, un video o un file de audio",
  "upload_error.limit": "Limite de incargamento de files excedite.",
  "upload_error.poll": "Incargamento de files non permittite con sondages.",
  "upload_error.quote": "Non es permittite incargar files con citationes.",
  "upload_form.drag_and_drop.instructions": "Pro prender un annexo multimedial, preme sur le barra de spatios o Enter. Trahente lo, usa le claves de flecha pro displaciar le annexo multimedial in un certe direction. Preme le barra de spatios o Enter de novo pro deponer le annexo multimedial in su nove position, o preme sur Escape pro cancellar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Le displaciamento ha essite cancellate. Le annexo multimedial {item} ha essite deponite.",
  "upload_form.drag_and_drop.on_drag_end": "Le annexo multimedial {item} ha essite deponite.",
  "upload_form.drag_and_drop.on_drag_over": "Le annexo multimedial {item} ha essite displaciate.",
  "upload_form.drag_and_drop.on_drag_start": "Le annexo multimedial {item} ha essite prendite.",
  "upload_form.edit": "Modificar",
  "upload_progress.label": "Incargante...",
  "upload_progress.processing": "Processante…",
  "username.taken": "Iste nomine de usator es ja in uso. Proba con un altere",
  "video.close": "Clauder le video",
  "video.download": "Discargar le file",
  "video.exit_fullscreen": "Sortir del schermo plen",
  "video.expand": "Expander video",
  "video.fullscreen": "Schermo plen",
  "video.hide": "Celar video",
  "video.mute": "Silentiar",
  "video.pause": "Pausa",
  "video.play": "Reproducer",
  "video.skip_backward": "Saltar a retro",
  "video.skip_forward": "Avantiar",
  "video.unmute": "Non plus silentiar",
  "video.volume_down": "Abassar le volumine",
  "video.volume_up": "Augmentar le volumine",
  "visibility_modal.button_title": "Definir visibilitate",
  "visibility_modal.direct_quote_warning.text": "Si tu salva le parametros actual, le citation incorporate se convertera in un ligamine.",
  "visibility_modal.header": "Visibilitate e interaction",
  "visibility_modal.helper.direct_quoting": "Le mentiones private scribite sur Mastodon non pote esser citate per alteres.",
  "visibility_modal.helper.privacy_editing": "Le visibilitate de un message non pote esser cambiate post su publication.",
  "visibility_modal.helper.privacy_private_self_quote": "Le auto-citationes de messages private non pote esser rendite public.",
  "visibility_modal.helper.private_quoting": "Le messages limitate al sequitores scribite sur Mastodon non pote esser citate per alteres.",
  "visibility_modal.helper.unlisted_quoting": "Quando un persona te cita, su message essera tamben celate del chronologia \"In tendentia\".",
  "visibility_modal.instructions": "Controla qui pote interager con iste message. Tu pote etiam applicar le parametros a tote le messages futur desde <link>Preferentias > Parametros de publication predefinite</link>.",
  "visibility_modal.privacy_label": "Visibilitate",
  "visibility_modal.quote_followers": "Solmente sequitores",
  "visibility_modal.quote_label": "Qui pote citar",
  "visibility_modal.quote_nobody": "Solo io",
  "visibility_modal.quote_public": "Omnes",
  "visibility_modal.save": "Salvar"
}
